export default {
  setGpathSession (context, payload) {
    return new Promise((resolve, reject) => {
      context.commit("setGpathSession", payload)
      resolve()
    })
  }
}
